export { default } from './NumbersFormModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersFormModal/index.js